<template>
	<div class="cm-wrapper cm-wrapper-list">
		<div class="cm-content cm-list-body">
			<div class="cm-list-body">
				<div class="pt-4 container">
					<div class="d-flex w-100">
						<div class="cm-sidebar">
							<list-sidebar
								:filter-init="filter.init"
								:filter-loading="filter.loading"
								:filter-fields="filter.fields"
								:count-total="list.countTotal"
								:ref-data="refData"
								@update-filter="getAllItems()"
							>
							</list-sidebar>
						</div>
						<div class="cm-list w-100">
							<div class="cm-list-top">
								<div class="card mb-3 d-none d-lg-block">
									<div class="card-body p-0">
										<ul class="nav list-topbar-nav">
											<li class="nav-item me-auto">
												<a
													class="nav-link"
													@click.prevent="
														this.$store.commit('deleteAllFilter'), getAllItems()
													"
													href="#"
													><i class="mdi mdi-reload"></i> Neue Suche</a
												>
											</li>
											<li class="nav-item">
												<a
													class="nav-link"
													data-bs-toggle="modal"
													href="#modalShareSearch"
												>
													<i class="mdi mdi-share-variant"></i> Suche teilen
												</a>
											</li>
											<li class="nav-item">
												<a
													class="nav-link"
													data-bs-toggle="modal"
													href="#modalBookmarks"
													><i class="mdi mdi-star"></i> Mein Merkzettel
													<transition name="cm-zoom-out">
														<span
															v-if="totalCarBookmarks > 0"
															class="badge bg-primary badge-upper"
															>{{ totalCarBookmarks }}
															<span class="visually-hidden">merkliste</span>
														</span>
													</transition>
												</a>
											</li>
										</ul>
									</div>
								</div>
								<div class="cm-list-top-box card mb-3">
									<div
										class="card-body card-body-text-search bg-white position-relative z-index-1"
									>
										<form-text-search
											@update-filter="getAllItems()"
										></form-text-search>
									</div>
									<div
										class="card-body pb-2 pt-2 bg-lighter position-relative z-index-1"
									>
										<span
											v-if="countActiveFilters === 1"
											class="lbl font-14 d-block"
											>Ein Filter aktiv</span
										>
										<span
											v-else-if="countActiveFilters > 1"
											class="lbl font-14 d-block"
											>{{ countActiveFilters }} Filter aktiv</span
										>
										<span
											v-else
											class="lbl font-14 d-block font-style-italic text-muted"
											>Kein Filter aktiv</span
										>
									</div>
									<list-filter-chips
										class-name-body="bg-lighter pt-0"
										:ref-data="refData"
										:filters="filter.fields"
										@update-filter="getAllItems()"
									></list-filter-chips>
								</div>

								<div class="row align-items-center justify-content-between">
									<div class="col-auto mb-2" v-if="!list.init">
										<h5 class="cm-hits-total">Lade Angebote...</h5>
										<span v-if="list.init" class="cm-pages"
											>Seite {{ list.page }} / {{ maxPage }}</span
										>
										<span v-else class="cm-pages">Seite 1 / 1</span>
									</div>
									<div v-else-if="list.countTotal > 0" class="col-auto mb-2">
										<h5 class="cm-hits-total">
											<vue3-autocounter
												ref="counter"
												:startAmount="countTotalOld"
												:endAmount="list.countTotal"
												:duration="1"
												suffix=" Angebote"
												:decimals="0"
												:autoinit="true"
												@finished="countTotalOld = list.countTotal"
											/>
										</h5>
										<span class="cm-pages"
											>Seite {{ list.page }} / {{ maxPage }}</span
										>
									</div>
									<div v-else class="col-auto mb-2">
										<h5 class="cm-hits-total">Keine Treffer</h5>
									</div>
									<div class="col-md-4 col-sm-6 mb-2 d-none d-sm-block">
										<form-select-sort
											v-if="list.init"
											@update-list="getListItems()"
										></form-select-sort>
									</div>
								</div>
							</div>
							<div class="cm-list-items" v-if="!list.init">
								<list-item-skeleton v-for="index in 20" :key="index" />
							</div>
							<div v-else-if="list.countTotal > 0" class="cm-list-items">
								<transition-group name="fliplist">
									<div
										v-for="(item, i) in list.items"
										:loading="list.loading"
										:key="item._id"
										:class="'item-' + i * 100"
									>
										<list-item-skeleton
											v-if="list.loading"
										></list-item-skeleton>
										<list-item
											v-else
											:car="item"
											:ref-data="refData"
										></list-item>
									</div>
								</transition-group>
							</div>
							<list-item-error v-else @update-filter="getAllItems" />
							<div class="cm-list-footer pb-4">
								<div class="row g-0 justify-content-between align-items-center">
									<div class="col-12 col-md-auto">
										<list-paging
											v-if="maxPage > 1"
											:page="list.page"
											:per-page="list.perPage"
											:count-total="list.countTotal"
											@go-to-page="getListItems()"
										></list-paging>
									</div>
									<div class="col-auto text-end" v-if="list.page">
										Seite {{ list.page }} / {{ maxPage }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<list-mobile-toolbar
			:ref-data="refData"
			:filter="filter"
			:list="list"
			:first-init="firstInit"
			:total-car-bookmarks="totalCarBookmarks"
			:count-active-filters="countActiveFilters"
			@update-filter="getAllItems()"
			@update-list="getListItems()"
		/>
		<template v-if="firstInit">
			<list-modal-bookmarks />
			<list-modal-share-search />
		</template>
	</div>
</template>

<script>
import ListItem from '@/components/list/ListItem'
import Vue3autocounter from 'vue3-autocounter'
import ListPaging from '@/components/list/ListPaging'
import FormTextSearch from '@/components/ui/form/FormTextSearch'
import ListSidebar from '@/components/list/ListSidebar'
import ListFilterChips from '@/components/list/ListFilterChips'
import FormSelectSort from '@/components/ui/form/FormSelectSort'
import PageLoader from '@/components/PageLoader'
import ListItemSkeleton from '@/components/list/ListItemSkeleton'
import store from '@/store'
import router from '@/router'
//import ListTopbar from '@/components/list/ListTopbar';
import ListItemError from '@/components/list/ListItemError'
import DarmasApiService from '@/services/DarmasApiService'
import ListModalBookmarks from '@/components/list/ListModalBookmarks'
import ListModalShareSearch from '@/components/list/ListModalShareSearch'
import ListMobileToolbar from '@/components/list/ListMobileToolbar'

export default {
	name: 'ListView',
	components: {
		ListItemError,
		ListItem,
		ListSidebar,
		FormSelectSort,
		ListFilterChips,
		FormTextSearch,
		ListPaging,
		ListItemSkeleton,
		ListModalBookmarks,
		ListModalShareSearch,
		ListMobileToolbar,
		'vue3-autocounter': Vue3autocounter,
	},
	props: {
		list: Object,
		filter: Object,
		loading: Boolean,
		firstInit: Boolean,
		refData: Object,
	},
	data() {
		return {
			countTotalOld: 0,
			search: {},
			mobile: {
				show: '',
			},
		}
	},
	computed: {
		totalCarBookmarks() {
			return Object.keys(store.state.user.bookmarks.cars).length
		},
		totalSearchBookmarks() {
			return store.state.user.bookmarks.search ? 1 : 0
		},
		bookmarkedCars() {
			return store.state.user.bookmarks.cars
		},
		shareSearchUrl() {
			return DarmasApiService.decodeFiltersFromStateToUrl(false, true)
		},
		shareSearchUrlWhatsapp() {
			return (
				'whatsapp://send?text=Meine gespeicherte Fahrzeugsuche ' +
				DarmasApiService.decodeFiltersFromStateToUrl(false, true)
			)
		},
		maxPage() {
			const maxPage = this.list.countTotal / this.list.perPage
			return Math.ceil(maxPage)
		},
		countActiveFilters() {
			let filters = Object.keys(store.state.filterItems).length
			if (store.state.price.filter !== 'fixed') {
				filters++
			}
			return store.state.search ? filters + 1 : filters
		},
	},
	methods: {
		getAllItems() {
			this.$emit('getAllItems')
		},
		getListItems() {
			this.$emit('getListItems')
		},
	},
}
</script>

<style lang="scss">
.fx-slide-vertical-enter-active,
.fx-slide-vertical-leave-active {
	position: relative;

	transition: all 0.3s ease;
}

.fx-slide-vertical-enter-from {
	position: relative;
	top: 0;
	opacity: 0;
}

.fx-slide-vertical-enter-to {
	position: relative;
	top: 0;
	opacity: 1;
}

.fx-slide-vertical-leave-from {
	position: relative;
	top: 0;
	opacity: 1;
}

.fx-slide-vertical-leave-to {
	position: relative;
	opacity: 0;
	top: 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

// Animation Fliplist

.fliplist-enter-active,
.fliplist-leave-active {
	transition: all 0.25s ease-in;
	transform: translateX(0);
}

.fliplist-enter-from {
	transform: translateX(-40px);
	opacity: 0;
}

.fliplist-leave-to {
	transform: translateX(40px);
	opacity: 0;
}

.zoom-enter-active,
.zoom-leave-active {
	transition: all 0.3s;
}

.zoom-enter-from,
.zoom-leave-to {
	opacity: 0;
}
</style>
